export default "__VITE_ASSET__CcguqP_l__"